import styled from 'styled-components';
import React from 'react';
import Loading from '../../../../shared/components/loading/Loading';

export const ClusterSwitchWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
`;

export const ClusterSwitchLoading = () => <ClusterSwitchWrapper><Loading height="30" /></ClusterSwitchWrapper>;
